import React from 'react';

const Loader = ({ text = "Processing..." }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4 text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary-600 mx-auto"></div>
        <div className="mt-4 text-lg font-semibold text-gray-700">{text}</div>
        <p className="mt-2 text-gray-500">This may take a few moments...</p>
      </div>
    </div>
  );
};

export default Loader;